import { render, staticRenderFns } from "./List.vue?vue&type=template&id=1a1348f7&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1348f7')) {
      api.createRecord('1a1348f7', component.options)
    } else {
      api.reload('1a1348f7', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=1a1348f7&", function () {
      api.rerender('1a1348f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/List.vue"
export default component.exports